import React, { lazy, Suspense } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import Screen from "./components/Screen";
import MMAChatBot from "./MMAChatBot";
import AccessibilityWidget from "./AccessibilityWidget";
import { Icons } from "./components/Icons";
import CookieConsent from "./CookieConsent";
import Adsense from "./Adsense";
const Home = lazy(() => import("./Pages/Home"));
const Header = lazy(() => import("./components/Header/index"));

const Styleapp = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

const AdsWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 0 !important;
  padding: 0 !important;

  min-height: 0 !important;
  height: auto;

  overflow: hidden;
  box-sizing: border-box;

  ins.adsbygoogle {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 0 !important;
    box-sizing: border-box !important;
  }
`;

function App() {
  return (
    <>
      <Styleapp>

        <Helmet>
          <title>
            אוחנה MMA | אומנויות לחימה כדרך חיים
          </title>

          <meta
            name="description"
            content="אוחנה MMA בבני ברק – אימוני MMA, ג׳יו ג׳יטסו, סטרייקינג והגנה עצמית לילדים, נוער ומבוגרים. אימונים מקצועיים עם דגש על כושר, משמעת וביטחון עצמי."
          />

          <meta
            name="keywords"
            content="אוחנה MMA, MMA בני ברק, אומנויות לחימה בני ברק, אימוני MMA בני ברק, ג׳יו ג׳יטסו בני ברק, הגנה עצמית בני ברק, MMA לילדים, MMA לנוער, MMA למבוגרים, סטרייקינג בני ברק"
          />

          <meta
            name="author"
            content="אורי אוחנה"
          />

          <meta
            name="robots"
            content="index, follow"
          />

          <link
            rel="canonical"
            href="https://teamohanamma.co.il/"
          />

          <meta
            property="og:type"
            content="website"
          />

          <meta
            property="og:title"
            content="אוחנה MMA | אומנויות לחימה ו-MMA בבני ברק"
          />

          <meta
            property="og:description"
            content="אימוני MMA, ג׳יו ג׳יטסו, סטרייקינג והגנה עצמית לילדים, נוער ומבוגרים בבני ברק."
          />

          <meta
            property="og:image"
            content="https://teamohanamma.co.il/logo192.jpg"
          />

          <meta
            property="og:url"
            content="https://teamohanamma.co.il/"
          />

          <meta
            property="og:site_name"
            content="אוחנה MMA"
          />

          <meta
            property="og:locale"
            content="he_IL"
          />

          <meta
            name="twitter:card"
            content="summary_large_image"
          />

          <meta
            name="twitter:title"
            content="אוחנה MMA | אומנויות לחימה ו-MMA בבני ברק"
          />

          <meta
            name="twitter:description"
            content="אימוני MMA, ג׳יו ג׳יטסו והגנה עצמית לילדים, נוער ומבוגרים בבני ברק."
          />

          <meta
            name="twitter:image"
            content="https://teamohanamma.co.il/logo192.jpg"
          />

          <meta
            name="geo.region"
            content="IL-TA"
          />

          <meta
            name="geo.placename"
            content="בני ברק"
          />
        </Helmet>

        <AccessibilityWidget />

        <Suspense fallback={null}>
          <Header />

          <Icons />

          <Screen />

          <Home />

          <CookieConsent />

          <AdsWrapper>
            <Adsense />
          </AdsWrapper>

          <MMAChatBot />
        </Suspense>

      </Styleapp>
    </>
  );
}

export default App;